import { Token } from '../token.class';
/**
 * Thrown when DI cannot inject value into property decorated by `@Inject` decorator.
 *
 * @group Errors
 */
export class CannotInstantiateValueError extends Error {
    get message() {
        return (`Cannot instantiate the requested value for the "${this.normalizedIdentifier}" identifier. ` +
            `The related metadata doesn't contain a factory or a type to instantiate.`);
    }
    constructor(identifier) {
        super();
        this.name = 'CannotInstantiateValueError';
        /** Normalized identifier name used in the error message. */
        this.normalizedIdentifier = '<UNKNOWN_IDENTIFIER>';
        // TODO: Extract this to a helper function and share between this and NotFoundError.
        if (typeof identifier === 'string') {
            this.normalizedIdentifier = identifier;
        }
        else if (identifier instanceof Token) {
            this.normalizedIdentifier = `Token<${identifier.name || 'UNSET_NAME'}>`;
        }
        else if (identifier && (identifier.name || identifier.prototype?.name)) {
            this.normalizedIdentifier =
                `MaybeConstructable<${identifier.name}>` ||
                    `MaybeConstructable<${identifier.prototype?.name}>`;
        }
    }
}
//# sourceMappingURL=cannot-instantiate-value.error.js.map